import {CURRENT_ITEM_LANDING, FETCH_ITEM_LANDING} from "../types";

export const initialState = {
    entities: [],
    entity: null,
};

export default function itemLandingReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_ITEM_LANDING:
            return {
                ...state,
                entities: action.payload
            };
        case CURRENT_ITEM_LANDING:
            return {
                ...state,
                entity: action.payload
            };
        default:
            return state;
    }
};
